import { AxiosError } from 'axios';

import { JOIN_ORG_API_URL } from '@/constants/apis';
import { configuration } from '@/constants/config';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { User } from '@/types/user.type';

export type JoinOrgApiPayload = {
  role: string;
  orgId: string;
  userId: string;
};

export const joinOrg = async (
  payload: JoinOrgApiPayload
): Promise<ApiResponse<User>> => {
  try {
    const response = await apiManager.post(JOIN_ORG_API_URL, payload, {
      baseURL: configuration.CLERK_API_URL,
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
